import React, { memo } from 'react';
import { Trans } from 'react-i18next';

import { ConfirmationModal } from '~/Components';
import { useLanguage } from '~/Hooks';
import { EventGroup } from '~/Models/DTO/EventGroup.model';
import { Typography } from '~/UIKit';

interface IDeleteEventGroupConfirmationModal {
  confirmationOptions: EventGroup;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteEventGroupConfirmationModal = memo(
  ({ confirmationOptions, onClose, onConfirm }: IDeleteEventGroupConfirmationModal) => {
    const { t } = useLanguage();

    return (
      <ConfirmationModal
        open
        title={t('app.delete')}
        cancel={{ action: onClose }}
        confirm={{ action: onConfirm, title: t('app.confirmationModal.delete') }}
        destructive
      >
        <Typography variant="body1">
          <Trans
            i18nKey="eventGroups.delete.message"
            values={{ eventName: confirmationOptions.name }}
            components={{ b: <b /> }}
          />
        </Typography>
        <Typography variant="body1">{t('app.confirmation.message')}</Typography>
      </ConfirmationModal>
    );
  },
);
